export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11011.6cd32cc0.jpg";